import { Alert, Box, Chip, Stack, Typography } from '@mui/material'
import React from 'react'
import { type ISlotNodeWarning } from '../../../../models/DistributionPlan'
import { translateUserFacingText } from '../../../../utils/userFacingTerminology'

interface SlotNodeWarningBannerProps {
  warnings: ISlotNodeWarning[]
  /** When true all entries are forced to error severity regardless of key */
  forceError?: boolean
}

function WarningEntry ({ warning }: { warning: ISlotNodeWarning }): JSX.Element {
  return (
    <Box>
      <Typography variant='body2'>{translateUserFacingText(warning.value)}</Typography>
      {warning.divisions.length > 0 && (
        <Stack direction='row' flexWrap='wrap' gap={0.5} mt={0.75}>
          {warning.divisions.map((d) => (
            <Chip key={d.abbreviation} label={d.abbreviation} title={d.title} size='small' />
          ))}
        </Stack>
      )}
    </Box>
  )
}

const SlotNodeWarningBanner: React.FC<SlotNodeWarningBannerProps> = ({ warnings, forceError = false }) => {
  if (warnings.length === 0) return null

  const hasError = forceError || warnings.some(w => w.key === 'error')
  const severity = hasError ? 'error' : 'warning'

  return (
    <Box sx={{ mt: 1, mb: 2 }}>
      <Alert severity={severity}>
        {warnings.length === 1
          ? <WarningEntry warning={warnings[0]} />
          : (
            <Stack spacing={1.5}>
              {warnings.map((w) => (
                <WarningEntry key={w.value} warning={w} />
              ))}
            </Stack>
            )}
      </Alert>
    </Box>
  )
}

export default SlotNodeWarningBanner
